import * as React from 'react';
import { default as GridCore, } from '@core-front/grid';
const filterBreak = (e) => {
    return e !== 'xxl';
};
export default class Grid extends React.Component {
    BEM() {
        const { align, gutter, noWrap, horizontalGutter, verticalGutter, reverse, wrap, className } = this.props;
        const classArray = [];
        if (gutter === 'medium' || gutter === 'smedium') {
            classArray.push(`grid--gutter-${gutter}`);
        }
        if (horizontalGutter === 'medium' || horizontalGutter === 'smedium') {
            classArray.push(`grid--horizontal-gutter-${horizontalGutter}`);
        }
        if (verticalGutter === 'medium' || verticalGutter === 'smedium') {
            classArray.push(`grid--vertical-gutter-${verticalGutter}`);
        }
        if (reverse && reverse.includes('xxl')) {
            classArray.push('grid--reverse-xxl');
        }
        if (wrap && wrap.includes('xxl')) {
            classArray.push('grid--wrap-xxl');
        }
        if (noWrap && typeof noWrap !== 'boolean' && noWrap.includes('xxl')) {
            classArray.push('grid--no-wrap-xxl');
        }
        if (align) {
            classArray.push(...align.filter((i) => i.includes('xxl')).map(i => 'grid--' + i));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    getGutter() {
        switch (this.props.gutter) {
            case 'medium':
            case 'smedium':
                return undefined;
            default:
                return this.props.gutter;
        }
    }
    getHorizontalGutter() {
        switch (this.props.horizontalGutter) {
            case 'medium':
            case 'smedium':
                return undefined;
            default:
                return this.props.horizontalGutter;
        }
    }
    getVerticalGutter() {
        switch (this.props.verticalGutter) {
            case 'medium':
            case 'smedium':
                return undefined;
            default:
                return this.props.verticalGutter;
        }
    }
    getReverse(reverse) {
        return reverse.filter(filterBreak);
    }
    getWrap(wrap) {
        return wrap.filter(filterBreak);
    }
    getNoWrap(noWrap) {
        if (!noWrap || typeof noWrap === 'boolean') {
            return noWrap;
        }
        return noWrap.filter(filterBreak);
    }
    getAlign(align) {
        return align.filter((e) => !e.endsWith('-xxl'));
    }
    render() {
        const { reverse, align, wrap, noWrap } = this.props;
        return (React.createElement(GridCore, Object.assign({}, this.props, { className: this.BEM(), gutter: this.getGutter(), horizontalGutter: this.getHorizontalGutter(), verticalGutter: this.getVerticalGutter(), reverse: reverse && this.getReverse(reverse), wrap: wrap && this.getWrap(wrap), align: align && this.getAlign(align), noWrap: typeof noWrap !== 'undefined' && this.getNoWrap(noWrap) }), this.props.children));
    }
}
